import { ACCESSORY_KEY } from '@yme/atoms/gallery/constants';
import { ACTION_IMAGE, KEY_IMAGE, STATIC_IMAGE, STUDIO_IMAGE } from '@yme/utils/constants';
export function isHeroSectionEmpty() {
    return true;
}
export const getUnitSharingPreviewImage = (_allVariantsImages) => {
    const imageNeedle = '001';
    const allVariantsImages = _allVariantsImages.filter((item) => !item.url.toLowerCase().includes(ACCESSORY_KEY));
    const actionImage = allVariantsImages?.find((item) => {
        const url = item.url.toLowerCase();
        return url.indexOf(ACTION_IMAGE) >= 0 && url.indexOf(imageNeedle) >= 0;
    });
    if (actionImage) {
        return actionImage.url;
    }
    const staticImage = allVariantsImages?.find((item) => {
        const url = item.url.toLowerCase();
        return url.indexOf(STATIC_IMAGE) >= 0 && url.indexOf(imageNeedle) >= 0;
    });
    if (staticImage) {
        return staticImage.url;
    }
    const studioImage = allVariantsImages?.find((item) => {
        const url = item.url.toLowerCase();
        return url.indexOf(STUDIO_IMAGE) >= 0 && url.indexOf(imageNeedle) >= 0;
    });
    if (studioImage) {
        return studioImage.url;
    }
    if (allVariantsImages.length) {
        return allVariantsImages[0].url;
    }
    return _allVariantsImages[0]?.url;
};
export const getPreviewImage = (masterData, allVariantsImages) => {
    const keyImage = masterData?.images?.find((item) => item.url.toLowerCase().indexOf(KEY_IMAGE) >= 0);
    if (keyImage) {
        return keyImage?.url;
    }
    const actionImage = allVariantsImages?.find((item) => item.url.toLowerCase().indexOf(ACTION_IMAGE) >= 0);
    if (actionImage) {
        return actionImage.url;
    }
    const staticImage = allVariantsImages?.find((item) => item.url.toLowerCase().indexOf(STATIC_IMAGE) >= 0);
    if (staticImage) {
        return staticImage.url;
    }
    const studioImage = allVariantsImages?.find((item) => item.url.toLowerCase().indexOf(STUDIO_IMAGE) >= 0);
    if (studioImage) {
        return studioImage.url;
    }
    return allVariantsImages[0]?.url;
};
